import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import {
  useAuthService
} from "../../services";
import {
  BackButton,
} from '../';
import logomark from '../../imgs/logomark.svg';
import './header.scss';

dayjs.extend(customParseFormat);

// The API sends recordReviewedByMember pre-formatted with the server's short
// date/time (e.g. "2024-01-09 15:45"). Parse it strictly — no time-zone shift,
// it's already local — and show it readably with a 12-hour clock
// (e.g. "January 9, 2024 3:45 PM"). Unknown layouts show as-is.
const reviewedOnInputFormats = ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD h:mm A', 'M/D/YYYY h:mm A'];
function formatReviewedOn(value) {
  if (!value) return '';
  const parsed = dayjs(value, reviewedOnInputFormats, true);
  return parsed.isValid() ? parsed.format('MMMM D, YYYY h:mm A') : value;
}

//{ title, recordReviewedByMember, form, save, undo, isDirty }
export default ({ title, editProfileInfo, menuToggleEnabled, toggleMenu, signOutVisible: showSignOut = true }) => {
  const signedOutPath = "/signed-out";
  const editProfilePath = "/edit-profile";

  const { pathname } = useLocation();
  const { signOut } = useAuthService();
  const navigate = useNavigate();
  const backButtonVisible = pathname !== "/" &&
    pathname !== signedOutPath;
  const signOutVisible = showSignOut && pathname !== signedOutPath;
  const onEditProfile = !!(pathname && pathname.includes(editProfilePath));
  return (
    <>
      <header className="header-component">
        <Toolbar className="header-toolbar">
          <Item
            location="before"
            cssClass="menu-button"
            visible={!!menuToggleEnabled}
          >
            <Button icon={logomark} stylingMode="text" hint="Menu" onClick={toggleMenu} />
          </Item>
          <Item
            location="before"
            visible={backButtonVisible}
          >
            <BackButton
              height="30px"
              width="30px"
            />
          </Item>
          <Item
            location="before"
            cssClass="header-title"
            visible={!!title}
          >
            <div id="headerTitle">
              {title}
            </div>
          </Item>

          <Item
            location="after"
          >
            {signOutVisible ? <Button icon="fa-solid fa-right-from-bracket" onClick={async () => { navigate("/signed-out"); signOut(); }} /> : <></>}
          </Item>
        </Toolbar>
      </header>
      {/* Edit Profile's review bar (outside the scrolling content, so it stays
          put). Its buttons live here rather than in the header toolbar, where
          they overlapped the page title on narrower screens. Unedited profile:
          one button to confirm it's up to date (saving updates Last Reviewed
          On). Once anything is edited: Undo + Save. */}
      {onEditProfile && (
        <header className="review-bar">
          <Toolbar className="review-toolbar">
            <Item location="before">
              <p className="last-reviewed">{`Last reviewed on ${formatReviewedOn(editProfileInfo.recordReviewedByMember)}`}</p>
            </Item>
            <Item location="after" visible={!editProfileInfo.isDirty}>
              <Button text="Confirm Up-to-Date" type="default" icon="fa-solid fa-circle-check" onClick={async () => {
                await editProfileInfo.save?.();
              }} />
            </Item>
            <Item location="after" visible={!!editProfileInfo.isDirty}>
              <Button text="Undo" type="default" icon="fa-solid fa-undo" onClick={async () => {
                await editProfileInfo.undo?.();
              }} />
            </Item>
            <Item location="after" visible={!!editProfileInfo.isDirty}>
              <Button text="Save" type="default" icon="check" onClick={async () => {
                await editProfileInfo.save?.();
              }} />
            </Item>
          </Toolbar>
        </header>
      )}
    </>
  )
};
